module.exports = __webpack_public_path__ + "static/media/logo-b.3ed9002b.svg";